import { Box, Typography } from '@mui/material'
import { COLORS } from '~theme/colors'

interface InfoBlockProps {
  label: string
  value: string | number | null | undefined
}

export function InfoBlock({ label, value }: InfoBlockProps) {
  const displayValue = value != null ? String(value) : '-'
  return (
    <Box sx={{ minWidth: 180, maxWidth: 250 }}>
      <Typography
        variant="label"
        component="label"
        sx={{ color: COLORS.greys.dark, display: 'block', mb: 0.5 }}
      >
        {label}
      </Typography>
      <Typography
        variant="paragraph2"
        color={COLORS.secondary.blue}
        sx={{ wordBreak: 'break-word' }}
      >
        {displayValue}
      </Typography>
    </Box>
  )
}
